import {Fragment, memo} from 'react';
import {useNumberFormatter} from '@ui/i18n/use-number-formatter';
import { Trans } from './trans';

interface FormattedCurrencyProps {
  value: number;
  currency: string;
  displayFreeText?: boolean;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}
export const FormattedCurrency = memo(
  ({
    value,
    currency,
    displayFreeText = false,
    minimumFractionDigits,
    maximumFractionDigits,
  }: FormattedCurrencyProps) => {
    const formatter = useNumberFormatter({
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits,
      maximumFractionDigits,
    });

    if (isNaN(value)) {
      value = 0;
    }

    if(displayFreeText && value === 0) return <Fragment><Trans message={'Free'} /></Fragment>

    return <Fragment>{formatter.format(value)}</Fragment>;
  },
);
